import { emitEvent } from "@/components/plugins/EventListener"

export const EVENT_SHOW_INLINE_LEAD_FORM = "show_inline_lead_form"
export const EVENT_CALC_ENGINE_LOADED = "calc_engine_loaded"

export const HASH_INLINE_LEAD_FORM = "inline_lead_form"

export const BUCKET_COOKIE = "_ua_bucket"

export function isSSR() {
  return (typeof window === 'undefined')
}

export function showInlineContactForm(params) {
  emitEvent(EVENT_SHOW_INLINE_LEAD_FORM, params)
}

export function calcDistance(lat1, lon1, lat2, lon2) {
  lat1 = parseFloat(lat1)
  lon1 = parseFloat(lon1)
  lat2 = parseFloat(lat2)
  lon2 = parseFloat(lon2)
  const r = 6371; // km
  const km2mi = 0.621371
  const p = Math.PI / 180;
  const a = 0.5 - Math.cos((lat2 - lat1) * p) / 2
                + Math.cos(lat1 * p) * Math.cos(lat2 * p) *
                  (1 - Math.cos((lon2 - lon1) * p)) / 2;
  return 2 * km2mi * r * Math.asin(Math.sqrt(a));
}

export function getBucket() {
  const buckets = ['a','a','b']
  // Get a random number between 0 and 1
  let n = cryptoRandom() * 100
  // Get the percentage of each bucket
  let percentage = 100 / buckets.length
  // Loop through the buckets and see if the random number falls
  // within the range of the bucket
  return (
    buckets.find(() => {
      n -= percentage
      return n <= 0
    }) ?? buckets[0]
  )
}

function cryptoRandom() {
  return crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1)
}

export function getCookiesFromString(cookiesString) {
  return cookiesString.split(";")
    .map(function (cookie) {
      if (cookie){
        return cookie.trim().split("=");
      } else {
        return []
      }
    })
    .reduce(function (acc, curr) {
      acc[curr[0]] = curr[1];
      return acc;
    }, {});
}
